import { CloudSun, type LucideIcon, Moon, Zap } from "lucide-react"

// Label-only; all minutes count equally. Matches the backend snake_case enum.
export type SleepType = "night" | "day_rest" | "nap"

interface SleepTypeMeta {
  value: SleepType
  label: string
  icon: LucideIcon
}

const NIGHT: SleepTypeMeta = { value: "night", label: "Nattsömn", icon: Moon }
const DAY_REST: SleepTypeMeta = { value: "day_rest", label: "Dagsvila", icon: CloudSun }
const NAP: SleepTypeMeta = { value: "nap", label: "Tupplur", icon: Zap }

export const SLEEP_TYPES: readonly SleepTypeMeta[] = [NIGHT, DAY_REST, NAP]

export function sleepTypeMeta(type: SleepType): SleepTypeMeta {
  // Neutral fallback for an unknown type.
  return SLEEP_TYPES.find((t) => t.value === type) ?? DAY_REST
}

// 19:00–07:00 → night, else day_rest.
export function defaultTypeForHour(hour: number): SleepType {
  return hour >= 19 || hour < 7 ? "night" : "day_rest"
}
